export default [
  {
    path: '/recruit/institution',
    name: 'institution',
    component: () => import('@/views/recruit/institution'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-art',
    name: 'landingpage',
    component: () => import('@/views/recruit/landingpageArt'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-reread',
    name: 'landingpageReread',
    component: () => import('@/views/recruit/landingpageReread'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-reread-spring',
    name: 'landingpageRereadSpring',
    component: () => import('@/views/recruit/landingpageRereadSpring'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-abroad',
    name: 'landingpageAbroad',
    component: () => import('@/views/recruit/landingpageAbroad'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-internate',
    name: 'landingpageInternate',
    component: () => import('@/views/recruit/landingpageInternate'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-zsb',
    name: 'landingpageZSB',
    component: () => import('@/views/recruit/landingpageZSB'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-grown',
    name: 'landingpageGrown',
    component: () => import('@/views/recruit/landingpageGrown'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-use',
    name: 'landingpageUse',
    component: () => import('@/views/recruit/landingpageUse'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-hmt',
    name: 'landingpageHMT',
    component: () => import('@/views/recruit/landingpageHMT'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/landingpage-camp',
    name: 'landingpageCamp',
    component: () => import('@/views/recruit/landingpageCamp'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/detail',
    name: 'detail',
    component: () => import('@/views/recruit/detail'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/mine',
    name: 'mine',
    component: () => import('@/views/recruit/mine'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/home',
    name: 'home',
    component: () => import('@/views/recruit/home'),
    meta: {
      title: '优质学校招生平台'
    }
  },
  {
    path: '/recruit/news',
    name: 'home',
    component: () => import('@/views/recruit/news'),
    meta: {
      title: '优质学校招生平台'
    }
  }
]
